"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "granarolo-dell-emilia": {
    "74bc2307": [{
      "hkey": "20761c09",
      "slug": "granarolo-dell-emilia",
      "name": "Granarolo dell'Emilia",
      "primary": true,
      "skipSearch": false
    }],
    "fibbia": [{
      "hkey": "20761c09",
      "slug": "granarolo-dell-emilia",
      "name": "Granarolo dell'Emilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4821b407": [{
      "hkey": "20761c09",
      "slug": "granarolo-dell-emilia",
      "name": "Granarolo dell'Emilia",
      "primary": true,
      "skipSearch": false
    }],
    "trappanino": [{
      "hkey": "20761c09",
      "slug": "granarolo-dell-emilia",
      "name": "Granarolo dell'Emilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;